import { useEffect, useState } from 'react';
import { fetchStatuses, statusStore } from '@/lib/stores/statusStore';
import { useSimplifiedUserData } from '@/providers/SimplifiedUserDataProvider';

/**
 * Hook to preload status data for the selected company and game
 * Status data is cached and reused across the application
 */
export function useStatusData() {
  const { selectedCompany, selectedGame } = useSimplifiedUserData();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadStatuses = async () => {
      if (!selectedCompany) return;

      // Check if we already have data in the store
      const existingData = statusStore.getData();
      if (existingData && existingData.length > 0) {
        return; // Data already loaded
      }

      setIsLoading(true);
      setError(null);

      try {
        await fetchStatuses(selectedCompany.id, selectedGame?.id);
      } catch (err) {
        const message = err instanceof Error ? err.message : 'Failed to load status data';
        setError(message);
        console.error('Failed to load status data:', err);
      } finally {
        setIsLoading(false);
      }
    };

    loadStatuses();
  }, [selectedCompany?.id, selectedGame?.id]);

  return { isLoading, error };
}

